export default __webpack_public_path__ + "static/media/4.8ad8a5f5.png";